import { DashboardTypes } from 'API';
import { useCampaignContext } from 'context/CampaignContext';
import { useClientContext } from 'context/ClientContext';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import { useTab } from './useParameters';

//TODO NEW DASHBOARD
const pathToDashType: Record<string, DashboardTypes> = {
  '/reporting/onlineportal': DashboardTypes.DIGITAL,
  '/reporting/searchportal': DashboardTypes.SEARCH,
  '/reporting/tvportal': DashboardTypes.TV,
  '/reporting/radioportal': DashboardTypes.RADIO,
  '/reporting/printportal': DashboardTypes.PRINT,
  '/reporting/oohportal': DashboardTypes.OOH,
  '/reporting/portal': DashboardTypes.FLOWCHART,
  '/reporting/cinemaportal': DashboardTypes.CINEMA,
  '/reporting': DashboardTypes.HOME,
  '/reporting/': DashboardTypes.HOME,
  '/reporting/insourcedataportal': DashboardTypes.INSOURCE_DATA,

  '/reporting/dataoverwrite': DashboardTypes.OVERWRITE,
};

export const useBackListener = () => {
  const location = useLocation();
  const navigate = useNavigate();
  //   const [tab, setTab] = useTab();

  const { setDashType } = useCampaignContext();
  const { isThereAnyReadPlus, anyPublish } = useClientContext();

  useEffect(() => {
    const dashType2 = pathToDashType[location.pathname.toLowerCase()];

    if (dashType2 /* && isThereAnyReadPlus !== undefined && anyPublish !== undefined */) {
      // Security guard: Check permission for FLOWCHART (campaign portal) access
      // Internal users: check anyPublish | External users: check isThereAnyReadPlus
      if (
        dashType2 === DashboardTypes.FLOWCHART &&
        isThereAnyReadPlus === false &&
        anyPublish === false
        //  &&
        // isThereAnyReadPlus !== undefined &&
        // anyPublish !== undefined
      ) {
        // Redirect unauthorized users to home dashboard
        console.warn('Unauthorized access attempt to campaign portal. Redirecting to home.');
        navigate('/reporting');
        setDashType(DashboardTypes.HOME);
        return;
      }

      setDashType(dashType2);
    }
  }, [location, isThereAnyReadPlus, anyPublish, navigate, setDashType]);
};
